<div class="page-title animatedBackground">
    <div class="container">
        <h3>Blog Details</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Blog Details</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="blog-details">
                    <div class="thumb">
                        <img src="assets/img/blog-details.jpg" alt="details">
                        <div class="date">
                            <span>12 Jan</span>
                        </div>
                    </div>
                    <div class="blog-details-heading">
                        <h3>10 Hot Marketing Trends You Need to Implement</h3>
                        <ul>
                            <li>Posted By: <a href="#">Admin</a></li>
                            <li><a href="#"><i class="icofont-comment"></i> 05</a></li>
                            <li><a href="#"><i class="icofont-thumbs-up"></i> 15</a></li>
                        </ul>
                    </div>
                    <div class="blog-details-content">
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus Page Maker including versions of Lorem Ipsum.</p>
                        <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                        <blockquote class="blockquote">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                            <footer class="blockquote-footer"><cite title="Source Title">John Smith</cite></footer>
                        </blockquote>
                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p>
                        <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p>
                        <p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.</p>
                        <div class="blog-details-meta">
                            <div class="tags">
                                <ul>
                                    <li class="title">Tags:</li>
                                    <li><a href="#">Medical</a></li>
                                    <li><a href="#">Dental</a></li>
                                    <li><a href="#">Doctor</a></li>
                                </ul>
                            </div>
                            <div class="share">
                                <ul>
                                    <li class="title">Share:</li>
                                    <li><a href="#"><i class="icofont-facebook"></i></a></li>
                                    <li><a href="#"><i class="icofont-x"></i></a></li>
                                    <li><a href="#"><i class="icofont-instagram"></i></a></li>
                                    <li><a href="#"><i class="icofont-x"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="blog-details-comments">
                            <h3 class="title">Comments (03)</h3>
                            <div class="single-comments">
                                <div class="thumb">
                                    <img src="assets/img/client-avatar1.jpg" alt="client">
                                </div>
                                <div class="content">
                                    <h4>Steven Smith</h4>
                                    <span>December 30, 2024</span>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                                    <a href="#">Reply <i class="icofont-reply"></i></a>
                                </div>
                            </div>
                            <div class="single-comments left-mr">
                                <div class="thumb">
                                    <img src="assets/img/client-avatar2.jpg" alt="client">
                                </div>
                                <div class="content">
                                    <h4>Eva Smith</h4>
                                    <span>December 30, 2024</span>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                                    <a href="#">Reply <i class="icofont-reply"></i></a>
                                </div>
                            </div>
                            <div class="border"></div>
                            <div class="single-comments">
                                <div class="thumb">
                                    <img src="assets/img/client-avatar3.jpg" alt="client">
                                </div>
                                <div class="content">
                                    <h4>John Doe</h4>
                                    <span>December 30, 2024</span>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                                    <a href="#">Reply <i class="icofont-reply"></i></a>
                                </div>
                            </div>
                            <div class="border"></div>
                            <div class="single-comments">
                                <div class="thumb">
                                    <img src="assets/img/client-avatar1.jpg" alt="client">
                                </div>
                                <div class="content">
                                    <h4>David Warner</h4>
                                    <span>December 30, 2024</span>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                                    <a href="#">Reply <i class="icofont-reply"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="blog-details-comments-form">
                            <h3 class="title">Leave a Reply</h3>
                            <form>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <input type="text" class="form-control" placeholder="Name">
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <input type="email" class="form-control" placeholder="Email">
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12">
                                        <div class="form-group">
                                            <textarea cols="30" rows="6" class="form-control" placeholder="Message"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12">
                                        <button class="btn btn-primary" type="submit">Submit <i class="fa fa-angle-double-right"></i></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="side-bar mb-0">
                    <div class="widget-box search-box">
                        <form>
                            <input type="text" placeholder="Search here..." class="form-control">
                            <button type="submit"><i class="icofont-search-2"></i></button>
                        </form>
                    </div>
                    <div class="widget-box categories-box">
                        <h3 class="title">Categories</h3>
                        <ul>
                            <li><a href="#"><i class="icofont-dotted-right"></i> Design Tutorials (5)</a></li>
                            <li><a href="#"><i class="icofont-dotted-right"></i> Branding (8)</a></li>
                            <li><a href="#"><i class="icofont-dotted-right"></i> Arts and Entertainment (4)</a></li>
                            <li><a href="#"><i class="icofont-dotted-right"></i> Blog Post (6)</a></li>
                            <li><a href="#"><i class="icofont-dotted-right"></i> Seo Analysis (3)</a></li>
                            <li><a href="#"><i class="icofont-dotted-right"></i> Online Marketing (15)</a></li>
                            <li><a href="#"><i class="icofont-dotted-right"></i> Email Marketing (12)</a></li>
                        </ul>
                    </div>
                    <div class="widget-box tags-box">
                        <h3 class="title">Tags</h3>
                        <ul>
                            <li><a href="#">Design</a></li>
                            <li><a href="#">Branding</a></li>
                            <li><a href="#">Entertainment</a></li>
                            <li><a href="#">Arts</a></li>
                            <li><a href="#">Blog Post</a></li>
                            <li><a href="#">Seo Analysis</a></li>
                            <li><a href="#">Marketing</a></li>
                            <li><a href="#">Email Marketing</a></li>
                        </ul>
                    </div>
                    <div class="widget-box recent-post-box mb-0">
                        <h3 class="title">Recent Post</h3>
                        <ul>
                            <li>
                                <div class="recent-post-thumb">
                                    <a href="#"><img src="assets/img/blog-img1.jpg" alt="pic"></a>
                                </div>
                                <div class="recent-post-desc">
                                    <h3><a href="#">How to Market Your Marketing Agency in 2024</a></h3>
                                    <span class="date">23 November 2024</span>
                                </div>
                            </li>
                            <li>
                                <div class="recent-post-thumb">
                                    <a href="#"><img src="assets/img/blog-img2.jpg" alt="pic"></a>
                                </div>
                                <div class="recent-post-desc">
                                    <h3><a href="#">15 Testing Tools for Optimizing Your Site</a></h3>
                                    <span class="date">23 November 2024</span>
                                </div>
                            </li>
                            <li>
                                <div class="recent-post-thumb">
                                    <a href="#"><img src="assets/img/blog-img3.jpg" alt="pic"></a>
                                </div>
                                <div class="recent-post-desc">
                                    <h3><a href="#">12 Tried-and-True Ways to Improve User Experience</a></h3>
                                    <span class="date">23 November 2024</span>
                                </div>
                            </li>
                            <li>
                                <div class="recent-post-thumb">
                                    <a href="#"><img src="assets/img/blog-img4.jpg" alt="pic"></a>
                                </div>
                                <div class="recent-post-desc">
                                    <h3><a href="#">The 13 Best Time Tracking Apps of 2024</a></h3>
                                    <span class="date">23 November 2024</span>
                                </div>
                            </li>
                            <li>
                                <div class="recent-post-thumb">
                                    <a href="#"><img src="assets/img/blog-img5.jpg" alt="pic"></a>
                                </div>
                                <div class="recent-post-desc">
                                    <h3><a href="#">How to Document Processes to Scale Agency</a></h3>
                                    <span class="date">23 November 2024</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>